import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PreparatoryTraining from "./tabs/PreparatoryTraining";
import { Wrapper } from "../styled";

const preporationTabs = [
  {
    title: "Профессиональная подготовка (для рабочих)",
    component: <PreparatoryTraining />,
  }
];

const Preporation: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {preporationTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {preporationTabs[tab].component}
    </Wrapper>
  );
};

export default Preporation;